import env from 'common/env';

export async function payBill(bill, moyen, banque, cheque) {
    const formData = new FormData();
    formData.append('payment', moyen);
    formData.append('bank', banque);
    formData.append('bankCheck', cheque);

    const result = await fetch(`${env}/domaine/pay-bill-event/${bill}`, {
        method: 'POST',
        body: formData
    })
        .then(res => (res.ok ? res.json() : false))
        .then(res => res)
        .catch(err => {
            console.error(err);
            throw 'Une erreur est survenue lors du règlement de la facture.';
        });

    return result;
}
